import createIcon from '../../createIcon';

/**
 * @component @name SecurityUpdateWarning
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuOTk0OSAxNUgxMC45OTQ5VjE3SDEyLjk5NDlWMTVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTIuOTk0OSA3SDEwLjk5NDlWMTNIMTIuOTk0OVY3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE2Ljk5NDkgMUg2Ljk5NDg4QzUuODk0ODggMSA1LjAwNDg4IDEuOSA1LjAwNDg4IDNWMjFDNS4wMDQ4OCAyMi4xIDUuODk0ODggMjMgNi45OTQ4OCAyM0gxNi45OTQ5QzE4LjA5NDkgMjMgMTguOTk0OSAyMi4xIDE4Ljk5NDkgMjFWM0MxOC45OTQ5IDEuOSAxOC4wOTQ5IDEgMTYuOTk0OSAxWk0xNi45OTQ5IDE4SDYuOTk0ODhWNkgxNi45OTQ5VjE4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SecurityUpdateWarning = createIcon('SecurityUpdateWarning', [
  ['path', { d: 'M12.9949 15H10.9949V17H12.9949V15Z', key: '14m1b1' }],
  ['path', { d: 'M12.9949 7H10.9949V13H12.9949V7Z', key: '1txkid' }],
  [
    'path',
    {
      d: 'M16.9949 1H6.99488C5.89488 1 5.00488 1.9 5.00488 3V21C5.00488 22.1 5.89488 23 6.99488 23H16.9949C18.0949 23 18.9949 22.1 18.9949 21V3C18.9949 1.9 18.0949 1 16.9949 1ZM16.9949 18H6.99488V6H16.9949V18Z',
      key: '1t3u71',
    },
  ],
]);

export default SecurityUpdateWarning;
